import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/home/ubuntu/download_production/699961e5f782d50014dd28c9_1782111867104_1be060b3/harextension/src/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/699961e5f782d50014dd28c9_1782111867104_1be060b3/harextension/src/styles/index.css");
